import React from "react"
import { useStaticQuery,  graphql } from 'gatsby'
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core'
import { GlobalStyle } from '../utils/styles'
import { useTranslation } from "react-i18next"

const ColorSelect = ({ currentProduct, colorSelectClick, backtoCompStage, revertColor, currentComp, currentDesign, currentColor, classes }) => {
  let colors, buttonColor
  const [activeColor, setColor] = React.useState(currentColor)
  const scrollableNodeRef = React.useRef(null);
  const scrollNavigation = (move) => {
    scrollableNodeRef.current.scrollTo({
      left: scrollableNodeRef.current.scrollLeft + move,
      behavior: 'smooth'
    });
  }
  if (currentProduct === 'quick-pocket') {
    switch(currentComp) {
      case 0:
        colors = ['black', 'violet', 'grey', 'beige', 'green', 'rust', 'garden' ]
        buttonColor = ['#000', '', '', '', '', '', '' ]
        break;
      case 1:
        colors = ['black', 'violet', 'grey', 'beige', 'green', 'rust', 'garden' ]
        buttonColor = ['#000', '', '', '', '', '', '' ]
        break;
      case 2:
        colors = ['black', 'violet', 'grey', 'beige', 'green', 'rust', 'garden' ]
        buttonColor = ['#000', '', '', '', '', '', '' ]
        break;
      case 3:
        colors = ['black', 'violet', 'grey', 'beige', 'green', 'rust', 'garden' ]
        buttonColor = ['#000', '', '', '', '', '', '' ]
        break;
      case 4:
        colors = ['black', 'violet', 'grey', 'beige', 'green', 'rust', 'garden' ]
        buttonColor = ['#000', '', '', '', '', '', '' ]
        break;
      case 5:
        colors = [ 'black_z', 'white_z' ]
        buttonColor = [ '#000', '#fff' ]
        break;
      case 6:
        colors = ['black_p', 'brown_p', 'grey_p']
        buttonColor = ['#000', '#562E1E', '#777']
        break;
      default:
        colors = ['classic', 'dark' ]
        buttonColor = ['#989893', '#332F30' ]
    }
  } else {
    switch(currentComp) {
      case 0:
        colors = ['black', 'violet', 'grey', 'beige', 'green', 'rust', 'garden' ]
        buttonColor = ['#000', '', '', '', '', '', '' ]
        break;
      case 1:
        colors = ['black', 'violet', 'grey', 'beige', 'green', 'rust', 'garden' ]
        buttonColor = ['#000', '', '', '', '', '', '' ]
        break;
      case 2:
        colors = ['black', 'violet', 'grey', 'beige', 'green', 'rust', 'garden' ]
        buttonColor = ['#000', '', '', '', '', '', '' ]
        break;
      case 3:
        colors = ['black_t', 'purple_t', 'green_t' ]
        buttonColor = ['#000', '#141337', '#2F392A' ]
        break;
      case 4:
        colors = ['black', 'violet', 'grey', 'beige', 'green', 'rust', 'garden' ]
        buttonColor = ['#000', '', '', '', '', '', '' ]
        break;
      case 5:
        colors = [ 'black_z', 'white_z' ]
        buttonColor = [ '#2B2523', '#fff' ]
        break;
      case 6:
        colors = ['black_p', 'brown_p', 'grey_p']
        buttonColor = ['#000', '#562E1E', '#777']
        break;
      default:
        colors = ['classic', 'dark' ]
        buttonColor = ['#989893', '#332F30']
    }
  }
  
  const data = useStaticQuery(graphql`
    query {
      garden: file(relativePath: { eq: "garden.jpg" }) {
        childImageSharp {
          fluid(base64Width: 840) {
            base64
          }
        }
      },
      rust: file(relativePath: { eq: "rust.jpg" }) {
        childImageSharp {
          fluid(base64Width: 840) {
            base64
          }
        }
      },
      green: file(relativePath: { eq: "green.jpg" }) {
        childImageSharp {
          fluid(base64Width: 840) {
            base64
          }
        }
      },
      beige: file(relativePath: { eq: "beige.jpg" }) {
        childImageSharp {
          fluid(base64Width: 840) {
            base64
          }
        }
      },
      grey: file(relativePath: { eq: "grey.jpg" }) {
        childImageSharp {
          fluid(base64Width: 840) {
            base64
          }
        }
      },
      violet: file(relativePath: { eq: "violet.jpg" }) {
        childImageSharp {
          fluid(base64Width: 840) {
            base64
          }
        }
      },
      black: file(relativePath: { eq: "black.jpg" }) {
        childImageSharp {
          fluid(base64Width: 840) {
            base64
          }
        }
      },
      webbing: file(relativePath: { eq: "webbing.jpg" }) {
        childImageSharp {
          fluid{
            base64
          }
        }
      }
    }
  `)

  const { t } = useTranslation()

  return (
    <div className="colorSelect">
      <h2 className="desktop">{ t('product.component')[currentDesign.case[currentComp].comp] }</h2>
      <div className="scrollButton-container" ref={scrollableNodeRef}>
        {colors.map((color, index) =>
          <div key={index} className="button__container">
            <Button
              onClick={() => {colorSelectClick(color); setColor(color)}}
              key={index}
              className={color === 'white' || color === 'white_z' ? 'black' : ''}
              style={{
                backgroundColor: buttonColor[index],
                backgroundImage: `url('${color === 'garden' ? data.garden.childImageSharp.fluid.base64 : color === 'rust' ? data.rust.childImageSharp.fluid.base64 : color === 'green' ? data.green.childImageSharp.fluid.base64 : color === 'beige' ? data.beige.childImageSharp.fluid.base64 : color === 'violet' ? data.violet.childImageSharp.fluid.base64 : color === 'grey' ? data.grey.childImageSharp.fluid.base64 : color === 'mesh' ? data.mesh.childImageSharp.fluid.src : (color === 'coyote' || color === 'navy') && currentComp === 6 ? data.point.childImageSharp.fluid.src : ''}')`,
                backgroundSize: `cover`,
                border: `1px solid #212121`,
                minWidth: `auto`,
                marginRight: `0`,
                borderRadius: `50%`
              }} >
              <i className={`icon icon-tick ${activeColor === color ? 'active' : ''} ${currentComp === 5 && color === 'white_z' ? 'black' : ''}`} />
            </Button>
            <div className="button__label">{ t('product.color')[color] }</div>
          </div>
        )}
      </div>
      <button style={{ display: colors.length > 4 ? 'show' : 'hide' }} onClick={() => scrollNavigation(-240)} className="scrollButton-prev mobile"><i className="icon icon-prevs"/></button>
      <button style={{ display: colors.length > 4 ? 'show' : 'hide' }} onClick={() => scrollNavigation(240)} className="scrollButton-next mobile"><i className="icon icon-nexts"/></button>
      <div className="buttonGroup stickToBottom">
        <Button className="basicButton outline" onClick={() => {backtoCompStage(); revertColor()}}>{ t('product.cancel') }</Button>
        <Button className="basicButton" onClick={() => backtoCompStage()}>{ t('product.confirm') }</Button>
      </div>
    </div>
  )
}

export default withStyles(GlobalStyle)(ColorSelect)

